import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import Veille from "@/pages/Veille";
import Article from "@/pages/Article";
import IAOutils from "@/pages/IAOutils";
import Reglementations from "@/pages/Reglementations";
import APropos from "@/pages/APropos";
import Ressources from "@/pages/Ressources";
import Newsletter from "@/pages/Newsletter";
import Unsubscribe from "@/pages/Unsubscribe";
import MentionsLegales from "@/pages/MentionsLegales";
import Politique from "@/pages/Politique";
import NotFound from "@/pages/NotFound";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import ArticlesList from "@/pages/admin/ArticlesList";
import ArticleEditor from "@/pages/admin/ArticleEditor";
import ArticlePreview from "@/pages/admin/ArticlePreview";
import Subscribers from "@/pages/admin/Subscribers";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/veille" element={<Veille />} />
              <Route path="/veille/:slug" element={<Article />} />
              <Route path="/ia-outils" element={<IAOutils />} />
              <Route path="/reglementations" element={<Reglementations />} />
              <Route path="/a-propos" element={<APropos />} />
              <Route path="/ressources" element={<Ressources />} />
              <Route path="/newsletter" element={<Newsletter />} />
              <Route path="/desinscription" element={<Unsubscribe />} />
              <Route path="/mentions-legales" element={<MentionsLegales />} />
              <Route path="/politique-de-confidentialite" element={<Politique />} />
              <Route path="*" element={<NotFound />} />
            </Route>

            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="articles" element={<ArticlesList />} />
              <Route path="articles/new" element={<ArticleEditor />} />
              <Route path="articles/:id/edit" element={<ArticleEditor />} />
              <Route path="articles/:id/preview" element={<ArticlePreview />} />
              <Route path="subscribers" element={<Subscribers />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
